import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import InputMask from 'react-input-mask';

export class ConfirmExistingCustomer extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    toggle() {
        this.props.toggle();
    }

    handleSubmit() {
        this.props.toggle();
        this.props.confirmMember();
    }



    render() {

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.toggle} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>Add Contact</ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        A customer already exists with the cell phone number.
                        Proceed with this customer?
                    </div>
                    <div className="form-group">
                        <label className="form-label semibold" >First Name</label>
                        <input type="text" disabled="true" className="form-control" value={this.props.firstname} />
                    </div>
                    <div className="form-group">
                        <label className="form-label semibold" >Last Name</label>
                        <input type="text" disabled="true" className="form-control" value={this.props.lastname} />
                    </div>
                    <div className="form-group">
                        <label className="form-label semibold" >Cell Phone</label>
                        <InputMask className="form-control" disabled="true" mask="(999) 999-9999" value={this.props.cellphone} maskChar=" " />
                    </div>


                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" className="btn btn-rounded" onClick={this.toggle}>Cancel</Button>
                    <Button color="primary" className="btn btn-rounded" onClick={this.handleSubmit}>Confirm</Button>{' '}
                </ModalFooter>
            </Modal>

        );
    }
}